import Waypoint from 'exports?Waypoint!waypoints/lib/noframework.waypoints.js'

/**
 * A fade in component.
 * @author Dayne Coulson-Hoffacker
 */
export default class InView {
  /**
   * Constructs a new section.
   * @param {Object} options - Options.
   * @param {HTMLElement} options.element - Container.
   * @param {Hurdler} options.hurdler - Hurdler instance.
   */
  constructor (options) {
    this.element = options.element
    const self = this
    new Waypoint({
      element: self.element,
      handler: () => {
        self.element.classList.add('visible')
      },
      offset: '60%'
    })
  }
}



// WEBPACK FOOTER //
// ./components/in-view/index.js